import React from 'react'

export default props => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13.95 16.45"
        {...props}
    >
        <path
            d="M989.77,507h-3.12a.47.47,0,0,1-.47-.54c.15-.87.28-1.75.42-2.62l.45-2.86c.13-.8.26-1.6.38-2.4s.29-1.85.44-2.77.27-1.72.41-2.59a1.88,1.88,0,0,1,.05-.33.74.74,0,0,1,.69-.52h5.37a7,7,0,0,1,2.3.37,3.1,3.1,0,0,1,1.21.71,2.94,2.94,0,0,1,.9,1.82,5.45,5.45,0,0,1,0,1.21.19.19,0,0,0,0,.08h0l-.06-.05-.42-.17a5.47,5.47,0,0,0-1.2-.26,6.84,6.84,0,0,0-.79-.05H992a.63.63,0,0,0-.52.27,1.12,1.12,0,0,0-.14.48l-.12.78c0,.16,0,.32-.08.48l-.09.63c0,.15-.05.3-.08.45l-.09.63c0,.15-.06.31-.08.46s-.09.59-.13.88-.09.5-.12.76c0,0,0,.09,0,.14a7.09,7.09,0,0,0-.14.78l-.15,1-.15.94-.15,1-.15.95C989.82,506.72,989.79,506.85,989.77,507Z"
            transform="translate(-986.18 -492.36)"
            fill="#474747"
        />
        <path
            d="M998.74,496.55h0a2.41,2.41,0,0,1,1.27,1.63,4.08,4.08,0,0,1,.08,1.35,6.66,6.66,0,0,1-.45,1.86,4.53,4.53,0,0,1-.93,1.47,4.1,4.1,0,0,1-1.6,1,6.18,6.18,0,0,1-1.59.34c-.36,0-.72,0-1.08,0a.64.64,0,0,0-.66.57l-.48,3c0,.16,0,.33-.08.49a.63.63,0,0,1-.63.53H990a.38.38,0,0,1-.39-.47l.21-1.3V507c0-.14.05-.27.07-.41l.15-.95.15-1,.15-.94.15-1a7.09,7.09,0,0,1,.14-.78.74.74,0,0,1,.72-.48h1.42a8.8,8.8,0,0,0,1.54-.12,5.58,5.58,0,0,0,2-.67,4.74,4.74,0,0,0,1.89-2,6.61,6.61,0,0,0,.45-1.22A6.71,6.71,0,0,0,998.74,496.55Z"
            transform="translate(-986.18 -492.36)"
            fill="#7a7a7a"
        />
        <path
            d="M998.74,496.55a6.71,6.71,0,0,1-.19.89,6.61,6.61,0,0,1-.45,1.22,4.74,4.74,0,0,1-1.89,2,5.58,5.58,0,0,1-2,.67,8.8,8.8,0,0,1-1.54.12H991.3a.74.74,0,0,0-.72.48c0-.05,0-.1,0-.14,0-.26.08-.51.12-.76s.09-.59.13-.88,0-.31.08-.46l.09-.63c0-.15,0-.3.08-.45l.09-.63c0-.16.06-.32.08-.48l.12-.78a1.12,1.12,0,0,1,.14-.48A.63.63,0,0,1,992,496h4.23a6.84,6.84,0,0,1,.79.05,5.47,5.47,0,0,1,1.2.26l.42.17Z"
            transform="translate(-986.18 -492.36)"
            fill="#383838"
        />
    </svg>
)
